module.exports = __webpack_public_path__ + "static/media/perspectives-purple.1d7ad298.svg";